import React from "react";
import "./styles.css";

const EmptyPage = ({ imgSrc, title, content }) => {
  return (
    <div className="empty-page-container">
      <div className="empty-page-img">
        <img src={imgSrc} alt={imgSrc} />
      </div>
      <div className="empty-page-meta">
        <div className="empty-page-title">{title}</div>
        <div className="empty-page-content">{content}</div>
      </div>
    </div>
  );
};

export default EmptyPage;
